import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export function* submitPecanAssessmentSaga({ payload }) {
  yield put(actions.setPecanAssessmentLoading(true));
  try {
    const { testAnswers } = payload;
    const response = yield call(Api.submitPecanAssessment, testAnswers);
    yield put(actions.setPecanAssessmentLoading(false));
    yield put(actions.submitPecanAssessmentSuccess(response.data.total));
  } catch (error) {
    yield put(actions.addError("dnata-test-submit", error));
    yield put(actions.setPecanAssessmentLoading(false));
  }
}

export function* submitPecanFormsSaga({ payload }) {
  yield put(actions.setPecanReadingLoading(true));
  try {
    const { content } = payload;
    yield call(Api.submitPecanForms, content);
    yield put(actions.setPecanReadingLoading(false));
    yield put(actions.submitPecanFormsSuccess());
  } catch (error) {
    yield put(actions.addError("post-pecan-forms", error));
    yield put(actions.setPecanReadingLoading(false));
  }
}

export function* markDocumentReadPecan({ payload }) {
  try {
    const filename = payload;
    yield call(Api.markDocumentRead, {
      document_read: filename,
      pecan: true,
    });
  } catch (error) {
    yield put(actions.addError("Reading List Pecan", error));
  }
}

export function* postPecanFormsSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postPecanForms, formName, formContent);
  } catch (error) {
    yield put(actions.addError("post-pecan-form", error));
  }
}
